module.exports = __webpack_public_path__ + "943f9ca6c0d5f0964ad49326c8da07f2.svg";